// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `app-modal-info {
  height: 100vh;
  position: relative;
}

.slide-col {
  top: 0;
  bottom: 0;
  position: absolute;
  display: flex;
  flex-direction: column;
  background-size: 100% 30vh !important;
  overflow: auto;
}
@media (max-width: 992px) {
  .slide-col .image-full-screen {
    display: none;
  }
}
@media (min-width: 991px) {
  .slide-col {
    display: flex;
    justify-content: space-between;
    flex-wrap: nowrap;
    flex-direction: row-reverse;
    background: #f8fafb;
  }
  .slide-col .image-full-screen {
    width: 50%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #ffffff 0%, #f5f7fa 100%);
    padding: 60px;
  }
  .slide-col .image-full-screen .image-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    align-self: center;
    justify-content: center;
  }
  .slide-col .image-full-screen .image-wrapper .block-item {
    display: flex;
    align-self: center;
    justify-content: center;
    width: 100%;
    position: relative;
    background: white;
    border-radius: 24px;
    padding: 40px;
    box-shadow: 0px 8px 32px rgba(7, 38, 51, 0.08);
  }
  .slide-col .image-full-screen .image-wrapper .main-img {
    max-width: 350px !important;
    max-height: 350px !important;
    width: auto !important;
    height: auto !important;
    object-fit: contain;
  }
  .slide-col .image-full-screen .image-wrapper .main-img.is-own-bowl {
    max-width: 400px !important;
    max-height: 400px !important;
  }
  .slide-col .left-part-desktop {
    width: 50%;
    border-right: none;
    background: white;
    display: flex;
    flex-direction: column;
  }
}

.back_btn_close {
  position: absolute;
  top: 10px;
  right: 15px;
  margin: 0px;
  background: transparent;
  width: 25px;
  height: 25px;
  padding: 0px;
  z-index: 99;
  border: none;
  cursor: pointer;
}
.back_btn_close ion-icon {
  width: 100%;
  height: 100%;
  margin: 0px;
}
@media (max-width: 992px) {
  .back_btn_close {
    left: 15px;
    right: auto;
    width: 32px;
    height: 32px;
  }
}
.back_btn_close.display-mobile {
  display: none;
}
@media (max-width: 992px) {
  .back_btn_close.display-mobile {
    display: block;
  }
}

.header-wrapper {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding-bottom: 0px;
  padding-top: 60px;
  align-items: center;
}
@media (max-width: 992px) {
  .header-wrapper {
    padding-top: 60px;
  }
}
.header-wrapper .back_btn {
  width: 30px;
  height: 30px;
}
@media (min-width: 991px) {
  .header-wrapper .back_btn {
    display: none;
  }
}

.option-group-col {
  flex-grow: 1;
  overflow: auto;
  flex-shrink: 1;
  flex-basis: auto;
  padding: 15px 10px;
  margin-bottom: 15px;
  display: flex;
}
@media (max-width: 992px) {
  .option-group-col {
    padding-bottom: 120px;
  }
}
.option-group-col.hidden {
  max-height: 0px;
  display: none;
}

.last-item {
  height: 75px;
}

.grow {
  flex-grow: 1;
  overflow: auto;
}

.back-img {
  position: absolute;
  top: 30px;
  left: 30px;
}

.image-wrapper {
  position: relative;
  background: #f5f5f5;
  border-radius: 24px;
}
@media (min-width: 991px) {
  .image-wrapper {
    display: none;
  }
}
@media (max-width: 992px) {
  .image-wrapper {
    background: #fff;
    padding: 0;
  }
}
.image-wrapper.no-image {
  min-height: 0;
  padding-top: 0;
  display: none;
}
@media (max-width: 992px) {
  .image-wrapper.no-image {
    display: none;
  }
}
.image-wrapper .category-background {
  position: absolute;
  z-index: 1;
  display: block;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100vw;
  height: 100%;
  font-family: Title;
  font-size: 30vw;
  line-height: 120%;
  letter-spacing: 0%;
  text-align: center;
  text-transform: uppercase;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (min-width: 991px) {
  .image-wrapper .category-background {
    width: 100%;
    font-size: 110px;
  }
}
.image-wrapper .back_icon {
  position: absolute;
  left: 10px;
  top: 10px;
  z-index: 99;
  zoom: 1.5;
}
.image-wrapper .cross_icon {
  z-index: 99;
  position: absolute;
  right: 10px;
  top: 10px;
  zoom: 1.5;
}

.main-img {
  height: 15vh;
  width: 100%;
  margin: 0 auto 0px;
  z-index: 2;
}
@media (max-width: 992px) {
  .main-img {
    height: auto;
    max-height: 330px;
    object-fit: contain;
  }
}

.default-img {
  height: 15vh;
  width: 100px !important;
}

.info {
  padding: 40px;
  flex: 1;
  display: flex;
  flex-direction: column;
}
@media (min-width: 991px) {
  .info {
    padding: 60px;
  }
}
.info .title {
  font-family: BricolageGrotesque;
  font-size: 32px;
  font-weight: 700;
  line-height: 120%;
  letter-spacing: -0.02em;
  text-align: left;
  vertical-align: middle;
  text-transform: capitalize;
  color: #072633;
  margin-bottom: 16px;
  padding-top: 0px;
}
@media (min-width: 991px) {
  .info .title {
    font-size: 36px;
    margin-bottom: 20px;
  }
}
.info .title .info_block {
  font-size: 20px;
  margin-left: 8px;
  cursor: pointer;
  margin-bottom: 4px;
  color: #2d69aa;
  transition: color 0.2s ease;
}
.info .title .info_block:hover {
  color: #4a90e2;
}
.info .desc {
  font-family: BricolageGrotesque;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0;
  text-align: left;
  vertical-align: middle;
  color: #5a6c7d;
  margin-bottom: 32px;
  padding-bottom: 32px;
  border-bottom: 1px solid #e8ecef;
}
@media (min-width: 991px) {
  .info .desc {
    font-size: 17px;
    line-height: 160%;
  }
}
.info .ingrediants-section {
  display: flex;
  justify-content: flex-end;
  padding: 10px 0px;
  align-items: center;
  width: 100%;
}
.info .ingrediants-section h3 {
  text-align: left;
  font-size: 18px;
  font-family: AppFontBold, sans-serif;
  line-height: var(--modal-info-desc-line-height);
  padding-bottom: 10px;
  color: var(--ion-color-secondary);
}
.info .ingrediants-section p {
  cursor: pointer;
  text-align: left;
  font-size: 16px;
  font-family: AppFontBold, sans-serif;
  line-height: var(--modal-info-desc-line-height);
  padding-bottom: 10px;
  color: var(--ion-color-primary);
  text-decoration: underline;
}
@media (max-width: 992px) {
  .info .ingrediants-section p {
    width: 50%;
    text-align: right;
  }
}

.menge {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0px 20px 20px;
}
.menge h5 {
  font-family: AppFontBold, sans-serif;
  font-size: 18px;
  text-transform: uppercase;
}

ion-button {
  position: relative;
}
ion-button .buuton-text {
  font-size: var(--modal-info-button-font-size);
  color: var(--color-black);
  font-family: AppFont, sans-serif;
  margin-right: 0;
}
ion-button .button-icon {
  position: absolute;
  right: 5px;
  height: 34px;
  width: 34px;
}

ion-toolbar {
  height: 60px;
  display: flex;
  align-items: center;
  --background: var(--background-color);
}
ion-toolbar ion-title {
  font-weight: 100;
  padding-inline: unset !important;
  font-size: 16px;
  text-align: left;
  margin-left: 40px;
  font-family: AppFontBold, sans-serif;
}
ion-toolbar ion-button {
  --background: transparent;
  --background-activated: transparent;
  --background-focused: transparent;
  --background-hover: transparent;
}
ion-toolbar ion-icon {
  padding: 8px;
  font-size: 15px;
}

swiper-container {
  width: 100% !important;
  height: 100% !important;
}

swiper-slide {
  width: 100% !important;
}

ion-page {
  background: transparent;
}

.slider-select-half {
  height: 100%;
  width: 100%;
}

.separator {
  height: 14px;
  width: 100%;
}
@media (min-width: 991px) and (max-height: 750px) {
  .separator {
    height: 11px;
  }
}

.allergens {
  margin: 5px 20px;
}
.allergens app-accordion-list {
  width: 100%;
}

.padding-block {
  padding: 0px 20px;
}

.vertical-line {
  content: " ";
  width: 1px;
  height: 20px;
  color: white;
  background: white;
  margin-inline: 10px;
}

.add-background {
  background-size: cover;
}

.button-footer-block {
  margin: 0px !important;
  background: #ffffff !important;
  padding: 24px 40px;
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  border-top: 1px solid #e8ecef;
}
@media (max-width: 992px) {
  .button-footer-block {
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 999;
    box-shadow: 0px -2px 16px rgba(7, 38, 51, 0.08);
    border-top: 1px solid #e8ecef;
    padding: 20px;
  }
}
@media (min-width: 991px) {
  .button-footer-block {
    width: 100%;
    padding: 32px 60px;
  }
}
.button-footer-block .left-button {
  background: #2d69aa;
  width: 100%;
  max-width: none;
  height: 58px;
  border-radius: 12px;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0px 4px 16px rgba(45, 105, 170, 0.3);
}
.button-footer-block .left-button:hover {
  background: #245489;
  transform: translateY(-2px);
  box-shadow: 0px 8px 24px rgba(45, 105, 170, 0.4);
}
.button-footer-block .left-button:active {
  transform: translateY(0);
}
.button-footer-block .left-button.disabled {
  opacity: 0.5;
  background: #b8c9d9;
  border-color: transparent;
  cursor: not-allowed;
  pointer-events: none;
  box-shadow: none;
}
.button-footer-block .left-button h2,
.button-footer-block .left-button p {
  font-family: BricolageGrotesque;
  font-weight: 600;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0.02em;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
  color: #fff;
  margin: 0;
}
@media (max-width: 992px) {
  .button-footer-block .left-button {
    width: 100%;
  }
}
.button-footer-block .button-checkout {
  width: -moz-fit-content;
  width: fit-content;
  max-width: 50%;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #2d69aa;
  border-radius: 26px;
}
.button-footer-block .button-checkout .left-price {
  background: #fff;
  height: 100%;
  border-radius: 26px;
  border: 1px solid #2d69aa;
  padding: 0px 10px;
  position: relative;
}
.button-footer-block .button-checkout .left-price .option-total-quantity {
  position: absolute;
  top: -10px;
  right: 0;
  height: 20px;
  width: 20px;
  border: 1px solid #000000;
  border-radius: 50px;
  background: #fff;
  color: #072633;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: BricolageGrotesque;
  font-size: 17px;
  letter-spacing: 0.08em;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
}
.button-footer-block .button-checkout.disabled {
  opacity: 0.5;
}
.button-footer-block .button-checkout.disabled {
  opacity: 0.5;
}
.button-footer-block .button-checkout p {
  font-family: BricolageGrotesque;
  font-size: 17px;
  line-height: 120%;
  letter-spacing: 2%;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
}
.button-footer-block .button-checkout .right-checkout {
  cursor: pointer;
  padding: 0px 15px 0px 10px;
  text-transform: uppercase;
  text-align: center;
}
.button-footer-block .button-checkout .right-checkout p {
  font-family: BricolageGrotesque;
  font-weight: 700;
  font-size: 17px;
  line-height: 120%;
  letter-spacing: 2%;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
  color: var(--color-white);
}

.center-element {
  display: flex;
  align-items: center;
  justify-content: center;
}

.style-block {
  height: 100%;
  overflow-y: auto;
  padding-bottom: 80px;
}
@media (max-width: 992px) {
  .style-block {
    height: auto;
    overflow-y: unset;
  }
}

@keyframes pulseColor {
  0% {
    color: var(--ion-color-primary);
  }
  30% {
    color: var(--color-black);
  }
  60% {
    color: var(--ion-color-primary);
  }
  100% {
    color: var(--color-black);
  }
}
.show-option-groups {
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: space-between;
}
.show-option-groups h1 {
  text-transform: uppercase;
  padding: 10px 20px;
}
.show-option-groups.error-item h1 {
  color: var(--color-black);
  animation: pulseColor 4s infinite alternate;
  text-transform: uppercase;
}
.show-option-groups ion-icon {
  transition: rotate 0.3s ease-in-out;
  margin-right: 20px;
  width: 15px;
  height: 15px;
}
.show-option-groups ion-icon.isOpen {
  rotate: 180deg;
}

.delete-option {
  position: absolute;
  bottom: -1px;
  right: 0%;
  z-index: 99;
  color: black;
  background: white;
  border-top-left-radius: 15px;
  text-align: center;
  padding: 7px;
  border-top: 2px dotted black;
  border-left: 2px dotted black;
}
.delete-option p {
  font-size: 13px;
  font-family: "AppFontBold";
  text-transform: uppercase;
  color: var(--ion-color-primary);
}

.vegan-block {
  display: flex;
  align-items: center;
}
.vegan-block ion-img {
  width: 35px;
  height: 24px;
}
.vegan-block p {
  text-transform: capitalize;
  margin-right: 5px;
  font-size: 12px;
  color: var(--ion-color-secondary);
}

.input-notes {
  padding: 20px 10px;
  position: relative;
}
.input-notes ion-label {
  position: absolute;
  top: 13px;
  left: 4%;
  background: #fff;
  color: #807d7d;
  font-size: 11px;
  z-index: 2;
  padding: 0 5px;
}
.input-notes ion-item {
  border: 1px solid #e5e5e5;
  --background: transparent;
  margin-bottom: 10px;
  margin-top: 0px;
  --padding-start: 0px;
  color: #072633;
  font-size: 14px;
  padding: 15px;
}
.input-notes ion-item ion-input {
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 90%;
  letter-spacing: 0%;
  vertical-align: middle;
  text-transform: uppercase;
}
.input-notes .container {
  position: relative;
}
.input-notes .container ion-label {
  font-family: AppFont;
  font-size: 11px;
  line-height: 85%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  text-transform: capitalize;
  color: var(--color-black);
}

.filters {
  width: 100%;
}
.filters app-menu-list-filters {
  width: 100%;
}

.price-row {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 32px;
  margin-top: auto;
}
.price-row .price {
  font-family: BricolageGrotesque;
  font-size: 28px;
  font-weight: 700;
  line-height: 120%;
  letter-spacing: -0.01em;
  text-align: left;
  vertical-align: middle;
  text-transform: none;
  color: #072633;
}
@media (min-width: 991px) {
  .price-row .price {
    font-size: 32px;
  }
}
.price-row .kcall {
  position: relative;
  font-size: 14px;
  line-height: 16.8px;
  letter-spacing: 0%;
  text-align: center;
  text-transform: uppercase;
}
.price-row .kcall,
.price-row .tags {
  position: relative;
  height: 17px;
  margin-left: 12px;
}
.price-row .kcall::before,
.price-row .tags::before {
  content: "";
  position: absolute;
  left: -6px;
  width: 1.5px;
  height: 100%;
  background: var(--color-black);
}

.opt-desc-row {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.opt-desc-row .option-group-limit {
  height: 100%;
  width: -moz-fit-content;
  width: fit-content;
  position: absolute;
  left: 4%;
  top: 50%;
  transform: translate(0, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: BricolageGrotesque;
  font-size: 14px;
  line-height: 120%;
  letter-spacing: 0%;
  vertical-align: middle;
  text-transform: uppercase;
}
.opt-desc-row .option-group-description {
  max-width: 37%;
  position: relative;
  font-family: Title;
  font-size: 24px;
  line-height: 120%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
}
.opt-desc-row .option-group-description::before, .opt-desc-row .option-group-description::after {
  content: "";
  position: absolute;
  top: 50%;
  width: 50px;
  height: 2px;
  background: var(--color-black);
}
.opt-desc-row .option-group-description::before {
  transform: translate(-100%, 0px);
  left: 0%;
}
.opt-desc-row .option-group-description::after {
  transform: translate(100%, 0px);
  right: 0%;
}

ion-textarea.custom {
  --border-width: 0;
}

.quantity-selector-block {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 25px;
  margin-bottom: 25px;
  border-bottom: 1px solid #dce8f5;
}
.quantity-selector-block .quantity-title {
  font-family: BricolageGrotesque;
  font-weight: 700;
  font-size: 16px;
  text-transform: capitalize;
  color: #393939;
}

.quantity-selector {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #9e5f2c;
  border-radius: 6px;
  width: -moz-fit-content;
  width: fit-content;
  background: transparent;
  z-index: 999;
}
.quantity-selector .quantity-btn {
  width: 9px;
  height: 11px;
  margin: 0px 10px;
  cursor: pointer;
}
.quantity-selector .quantity {
  width: 30px;
  height: 30px;
  font-family: AppFontBold;
  border-left: 1px solid #9e5f2c;
  border-right: 1px solid #9e5f2c;
  font-size: 15px;
  line-height: 85%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  text-transform: capitalize;
  display: flex;
  align-items: center;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/app/components/modal-info/modal-info.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAMA;EACC,aAAA;EACA,kBAAA;AALD;;AAQA;EACC,MAAA;EACA,SAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,qCAAA;EACA,cAAA;AALD;ACNE;EDaA;IACC,aAAA;EAJD;AACF;ACjBE;EDUF;IAcE,aAAA;IACA,8BAAA;IACA,iBAAA;IACA,2BAAA;IACA,mBAAA;EAHA;EAKA;IACC,UAAA;IACA,YAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,6DAAA;IACA,aAAA;EAHD;EAKC;IACC,WAAA;IACA,YAAA;IACA,aAAA;IACA,kBAAA;IACA,uBAAA;EAHF;EAKE;IACC,aAAA;IACA,kBAAA;IACA,uBAAA;IACA,WAAA;IACA,kBAAA;IACA,iBAAA;IACA,mBAAA;IACA,aAAA;IACA,8CAAA;EAHH;EAME;IACC,2BAAA;IACA,4BAAA;IACA,sBAAA;IACA,uBAAA;IACA,mBAAA;EAJH;EAKG;IACC,2BAAA;IACA,4BAAA;EAHJ;EAQA;IACC,UAAA;IACA,kBAAA;IACA,iBAAA;IACA,aAAA;IACA,sBAAA;EAND;AACF;;AASA;EACC,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AAND;AAOC;EACC,WAAA;EACA,YAAA;EACA,WAAA;AALF;ACpFE;ED0EF;IAqBE,UAAA;IACA,WAAA;IACA,WAAA;IACA,YAAA;EAPA;AACF;AAQC;EACC,aAAA;AANF;AC/FE;EDoGD;IAGE,cAAA;EAJD;AACF;;AAOA;EACC,WAAA;EACA,aAAA;EACA,8BAAA;EAEA,mBAAA;EACA,iBAAA;EACA,mBAAA;AALD;AC7GE;ED2GF;IASE,iBAAA;EAHA;AACF;AAIC;EACC,WAAA;EACA,YAAA;AAFF;AC5HE;ED4HD;IAIE,aAAA;EAAD;AACF;;AAGA;EACC,YAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;AAAD;ACrIE;ED8HF;IAWE,qBAAA;EAAA;AACF;AAEC;EACC,eAAA;EACA,aAAA;AAAF;;AAGA;EACC,YAAA;AAAD;;AAGA;EACC,YAAA;EACA,cAAA;AAAD;;AAGA;EACC,kBAAA;EACA,SAAA;EACA,UAAA;AAAD;;AAEA;EAKC,kBAAA;EACA,mBAAA;EACA,mBAAA;AAHD;ACzKE;EDqKF;IAEE,aAAA;EAMA;AACF;ACxKE;ED+JF;IAUE,gBAAA;IACA,UAAA;EAGA;AACF;AADC;EACC,aAAA;EACA,cAAA;EACA,aAAA;AAGF;ACnLE;ED6KD;IAME,aAAA;EAID;AACF;AADC;EACC,kBAAA;EACA,UAAA;EACA,cAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAGF;AClNE;ED6LD;IAqBE,WAAA;IACA,gBAAA;EAID;AACF;AADC;EACC,kBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,SAAA;AAGF;AADC;EACC,WAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,SAAA;AAGF;;AAAA;EACC,YAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;AAGD;ACvOE;EDgOF;IAQE,YAAA;IACA,iBAAA;IACA,mBAAA;EAGA;AACF;;AAGA;EACC,YAAA;EACA,uBAAA;AAAD;;AAEA;EACC,aAAA;EACA,OAAA;EACA,aAAA;EACA,sBAAA;AACD;AChQE;ED2PF;IAOE,aAAA;EAEA;AACF;AAAC;EACC,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,sBAAA;EACA,0BAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AAEF;AClRE;EDqQD;IAcE,eAAA;IACA,mBAAA;EAGD;AACF;AADE;EACC,eAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,2BAAA;AAGH;AADG;EACC,cAAA;AAGJ;AAEC;EACC,+BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;EACA,mBAAA;EACA,oBAAA;EACA,gCAAA;AAAF;AChTE;EDqSD;IAcE,eAAA;IACA,iBAAA;EACD;AACF;AACC;EACC,aAAA;EACA,yBAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;AACF;AAAE;EACC,gBAAA;EACA,eAAA;EACA,oCAAA;EAEA,+CAAA;EACA,oBAAA;EACA,iCAAA;AACH;AACE;EACC,eAAA;EACA,gBAAA;EACA,eAAA;EACA,oCAAA;EAEA,+CAAA;EACA,oBAAA;EACA,+BAAA;EACA,0BAAA;AAAH;ACzUE;EDgUA;IAWE,UAAA;IACA,iBAAA;EAEF;AACF;;AAGA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EAMA,qBAAA;AALD;AAAC;EACC,oCAAA;EACA,eAAA;EACA,yBAAA;AAEF;;AAGA;EACC,kBAAA;AAAD;AAEC;EACC,6CAAA;EACA,yBAAA;EACA,gCAAA;EACA,eAAA;AAAF;AAEC;EACC,kBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;AAAF;;AAIA;EACC,YAAA;EACA,aAAA;EACA,mBAAA;EACA,qCAAA;AADD;AAEC;EACC,gBAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,oCAAA;AAAF;AAEC;EACC,yBAAA;EACA,mCAAA;EACA,iCAAA;EACA,+BAAA;AAAF;AAGC;EACC,YAAA;EACA,eAAA;AADF;;AAIA;EACC,sBAAA;EACA,uBAAA;AADD;;AAIA;EACC,sBAAA;AADD;;AAGA;EACC,uBAAA;AAAD;;AAEA;EACC,YAAA;EACA,WAAA;AACD;;AACA;EACC,YAAA;EACA,WAAA;AAED;AAEE;EANF;IAOG,YAAA;EACD;AACF;;AAEA;EACC,gBAAA;AACD;AAAC;EACC,WAAA;AAEF;;AACA;EACC,iBAAA;AAED;;AAAA;EACC,YAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;AAGD;;AADA;EAEC,sBAAA;AAGD;;AADA;EACC,sBAAA;EACA,8BAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,6BAAA;AAID;ACrcE;EDubF;IAcE,eAAA;IACA,SAAA;IACA,OAAA;IACA,YAAA;IACA,+CAAA;IACA,6BAAA;IACA,aAAA;EAIA;AACF;ACtdE;ED6bF;IAwBE,WAAA;IACA,kBAAA;EAKA;AACF;AAHC;EACC,mBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iDAAA;EACA,gDAAA;AAKF;AAHE;EACC,mBAAA;EACA,2BAAA;EACA,gDAAA;AAKH;AAFE;EACC,wBAAA;AAIH;AADE;EACC,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;AAGH;AAEE;;EAEC,+BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,WAAA;EACA,SAAA;AAAH;ACjgBE;EDmdD;IAiDE,WAAA;EACD;AACF;AAEC;EACC,uBAAA;EAAA,kBAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AAAF;AACE;EACC,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;AACH;AACG;EACC,kBAAA;EACA,UAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,+BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;AAAJ;AAME;EACC,YAAA;AAJH;AAME;EACC,YAAA;AAJH;AAME;EACC,+BAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;AAJH;AAOE;EACC,eAAA;EACA,0BAAA;EAaA,yBAAA;EACA,kBAAA;AAjBH;AAKG;EACC,+BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,yBAAA;AAHJ;;AAUA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;AAPD;;AASA;EACC,YAAA;EACA,gBAAA;EACA,oBAAA;AAND;ACxlBE;ED2lBF;IAKE,YAAA;IACA,iBAAA;EAJA;AACF;;AAOA;EACC;IACC,+BAAA;EAJA;EAMD;IACC,yBAAA;EAJA;EAMD;IACC,+BAAA;EAJA;EAMD;IACC,yBAAA;EAJA;AACF;AAMA;EACC,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;AAJD;AAKC;EACC,yBAAA;EACA,kBAAA;AAHF;AAME;EACC,yBAAA;EACA,2CAAA;EACA,yBAAA;AAJH;AAOC;EACC,mCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AALF;AAME;EACC,cAAA;AAJH;;AAQA;EACC,kBAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,4BAAA;EACA,kBAAA;EACA,YAAA;EACA,4BAAA;EACA,6BAAA;AALD;AAMC;EACC,eAAA;EACA,0BAAA;EACA,yBAAA;EACA,+BAAA;AAJF;;AAOA;EACC,aAAA;EACA,mBAAA;AAJD;AAKC;EACC,WAAA;EACA,YAAA;AAHF;AAKC;EACC,0BAAA;EACA,iBAAA;EACA,eAAA;EACA,iCAAA;AAHF;;AAMA;EACC,kBAAA;EACA,kBAAA;AAHD;AAKC;EACC,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,UAAA;EACA,cAAA;AAHF;AAKC;EACC,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;AAHF;AAIE;EACC,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;AAFH;AAKC;EACC,kBAAA;AAHF;AAIE;EACC,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,0BAAA;EAEA,yBAAA;AAHH;;AAOA;EACC,WAAA;AAJD;AAKC;EACC,WAAA;AAHF;;AAUA;EACC,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AAPD;AASC;EACC,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,sBAAA;EACA,oBAAA;EACA,cAAA;AAPF;ACtvBE;EDovBD;IAYE,eAAA;EAND;AACF;AASC;EACC,kBAAA;EAEA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;AARF;AAUC;;EAEC,kBAAA;EACA,YAAA;EACA,iBAAA;AARF;AAWC;;EAEC,WAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,8BAAA;AATF;;AAaA;EACC,kBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAVD;AAYC;EACC,YAAA;EACA,uBAAA;EAAA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,QAAA;EACA,6BAAA;EAEA,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,+BAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;AAZF;AAeC;EACC,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;AAbF;AAeE;EAEC,WAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,8BAAA;AAdH;AAiBE;EACC,gCAAA;EAEA,QAAA;AAhBH;AAkBE;EACC,+BAAA;EACA,SAAA;AAhBH;;AAoBA;EACC,iBAAA;AAjBD;;AAmBA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,gCAAA;AAhBD;AAkBC;EACC,+BAAA;EACA,gBAAA;EACA,eAAA;EACA,0BAAA;EACA,cAAA;AAhBF;;AAmBA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,uBAAA;EACA,kBAAA;EACA,uBAAA;EACA,YAAA;AAhBD;AAkBC;EACC,UAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;AAhBF;AAkBC;EACC,WAAA;EACA,YAAA;EACA,wBAAA;EACA,8BAAA;EACA,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAhBF","sourcesContent":["@import '../../../theme/mixins';\n\n:host {\n\t// background: #e8e8e0;\n}\n\napp-modal-info {\n\theight: 100vh;\n\tposition: relative;\n}\n\n.slide-col {\n\ttop: 0;\n\tbottom: 0;\n\tposition: absolute;\n\tdisplay: flex;\n\tflex-direction: column;\n\tbackground-size: 100% 30vh !important;\n\toverflow: auto;\n\t@include mobile {\n\t\t.image-full-screen {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\t@include desktop {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tflex-wrap: nowrap;\n\t\tflex-direction: row-reverse;\n\t\tbackground: #f8fafb;\n\n\t\t.image-full-screen {\n\t\t\twidth: 50%;\n\t\t\theight: 100%;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\tbackground: linear-gradient(135deg, #ffffff 0%, #f5f7fa 100%);\n\t\t\tpadding: 60px;\n\n\t\t\t.image-wrapper {\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 100%;\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-self: center;\n\t\t\t\tjustify-content: center;\n\n\t\t\t\t.block-item {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-self: center;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tbackground: white;\n\t\t\t\t\tborder-radius: 24px;\n\t\t\t\t\tpadding: 40px;\n\t\t\t\t\tbox-shadow: 0px 8px 32px rgba(7, 38, 51, 0.08);\n\t\t\t\t}\n\n\t\t\t\t.main-img {\n\t\t\t\t\tmax-width: 350px !important;\n\t\t\t\t\tmax-height: 350px !important;\n\t\t\t\t\twidth: auto !important;\n\t\t\t\t\theight: auto !important;\n\t\t\t\t\tobject-fit: contain;\n\t\t\t\t\t&.is-own-bowl {\n\t\t\t\t\t\tmax-width: 400px !important;\n\t\t\t\t\t\tmax-height: 400px !important;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.left-part-desktop {\n\t\t\twidth: 50%;\n\t\t\tborder-right: none;\n\t\t\tbackground: white;\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t}\n\t}\n}\n.back_btn_close {\n\tposition: absolute;\n\ttop: 10px;\n\tright: 15px;\n\tmargin: 0px;\n\tbackground: transparent;\n\twidth: 25px;\n\theight: 25px;\n\tpadding: 0px;\n\tz-index: 99;\n\tborder: none;\n\tcursor: pointer;\n\tion-icon {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tmargin: 0px;\n\t}\n\t&:hover {\n\t\t// background: #f2dbd9;\n\t}\n\t@include mobile {\n\t\tleft: 15px;\n\t\tright: auto;\n\t\twidth: 32px;\n\t\theight: 32px;\n\t}\n\t&.display-mobile {\n\t\tdisplay: none;\n\t\t@include mobile {\n\t\t\tdisplay: block;\n\t\t}\n\t}\n}\n.header-wrapper {\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\t// padding: 20px;\n\tpadding-bottom: 0px;\n\tpadding-top: 60px;\n\talign-items: center;\n\t@include mobile {\n\t\tpadding-top: 60px;\n\t}\n\t.back_btn {\n\t\twidth: 30px;\n\t\theight: 30px;\n\t\t@include desktop {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n.option-group-col {\n\tflex-grow: 1;\n\toverflow: auto;\n\tflex-shrink: 1;\n\tflex-basis: auto;\n\tpadding: 15px 10px;\n\tmargin-bottom: 15px;\n\tdisplay: flex;\n\n\t// Mobile: add padding for fixed button at bottom\n\t@include mobile {\n\t\tpadding-bottom: 120px; // Extra space for fixed button\n\t}\n\n\t&.hidden {\n\t\tmax-height: 0px;\n\t\tdisplay: none;\n\t}\n}\n.last-item {\n\theight: 75px;\n}\n\n.grow {\n\tflex-grow: 1;\n\toverflow: auto;\n}\n\n.back-img {\n\tposition: absolute;\n\ttop: 30px;\n\tleft: 30px;\n}\n.image-wrapper {\n\t@include desktop {\n\t\tdisplay: none;\n\t}\n\t// background: black url('../../../assets/losteria/modal-info.png') no-repeat center center / 100% 100%;\n\tposition: relative;\n\tbackground: #f5f5f5;\n\tborder-radius: 24px;\n\n\t@include mobile {\n\t\tbackground: #fff;\n\t\tpadding: 0;\n\t}\n\n\t&.no-image {\n\t\tmin-height: 0;\n\t\tpadding-top: 0;\n\t\tdisplay: none;\n\n\t\t@include mobile {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t.category-background {\n\t\tposition: absolute;\n\t\tz-index: 1;\n\t\tdisplay: block;\n\t\ttop: 50%;\n\t\tleft: 50%;\n\t\ttransform: translate(-50%, -50%);\n\t\twidth: 100vw;\n\t\theight: 100%;\n\t\tfont-family: Title;\n\t\tfont-size: 30vw;\n\t\tline-height: 120%;\n\t\tletter-spacing: 0%;\n\t\ttext-align: center;\n\t\ttext-transform: uppercase;\n\t\tcolor: #fff;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\n\t\t@include desktop {\n\t\t\twidth: 100%;\n\t\t\tfont-size: 110px;\n\t\t}\n\t}\n\n\t.back_icon {\n\t\tposition: absolute;\n\t\tleft: 10px;\n\t\ttop: 10px;\n\t\tz-index: 99;\n\t\tzoom: 1.5;\n\t}\n\t.cross_icon {\n\t\tz-index: 99;\n\t\tposition: absolute;\n\t\tright: 10px;\n\t\ttop: 10px;\n\t\tzoom: 1.5;\n\t}\n}\n.main-img {\n\theight: 15vh;\n\twidth: 100%;\n\tmargin: 0 auto 0px;\n\tz-index: 2;\n\n\t@include mobile {\n\t\t// height: 33vh;\n\t\theight: auto;\n\t\tmax-height: 330px;\n\t\tobject-fit: contain;\n\t}\n\n\t// &.full-width {\n\t//   object-fit: cover;\n\t// }\n}\n.default-img {\n\theight: 15vh;\n\twidth: 100px !important;\n}\n.info {\n\tpadding: 40px;\n\tflex: 1;\n\tdisplay: flex;\n\tflex-direction: column;\n\n\t@include desktop {\n\t\tpadding: 60px;\n\t}\n\n\t.title {\n\t\tfont-family: BricolageGrotesque;\n\t\tfont-size: 32px;\n\t\tfont-weight: 700;\n\t\tline-height: 120%;\n\t\tletter-spacing: -0.02em;\n\t\ttext-align: left;\n\t\tvertical-align: middle;\n\t\ttext-transform: capitalize;\n\t\tcolor: #072633;\n\t\tmargin-bottom: 16px;\n\t\tpadding-top: 0px;\n\n\t\t@include desktop {\n\t\t\tfont-size: 36px;\n\t\t\tmargin-bottom: 20px;\n\t\t}\n\n\t\t.info_block {\n\t\t\tfont-size: 20px;\n\t\t\tmargin-left: 8px;\n\t\t\tcursor: pointer;\n\t\t\tmargin-bottom: 4px;\n\t\t\tcolor: #2d69aa;\n\t\t\ttransition: color 0.2s ease;\n\n\t\t\t&:hover {\n\t\t\t\tcolor: #4a90e2;\n\t\t\t}\n\t\t}\n\t}\n\n\t.desc {\n\t\tfont-family: BricolageGrotesque;\n\t\tfont-weight: 400;\n\t\tfont-size: 16px;\n\t\tline-height: 150%;\n\t\tletter-spacing: 0;\n\t\ttext-align: left;\n\t\tvertical-align: middle;\n\t\tcolor: #5a6c7d;\n\t\tmargin-bottom: 32px;\n\t\tpadding-bottom: 32px;\n\t\tborder-bottom: 1px solid #e8ecef;\n\n\t\t@include desktop {\n\t\t\tfont-size: 17px;\n\t\t\tline-height: 160%;\n\t\t}\n\t}\n\t.ingrediants-section {\n\t\tdisplay: flex;\n\t\tjustify-content: flex-end;\n\t\tpadding: 10px 0px;\n\t\talign-items: center;\n\t\twidth: 100%;\n\t\th3 {\n\t\t\ttext-align: left;\n\t\t\tfont-size: 18px;\n\t\t\tfont-family: AppFontBold, sans-serif;\n\n\t\t\tline-height: var(--modal-info-desc-line-height);\n\t\t\tpadding-bottom: 10px;\n\t\t\tcolor: var(--ion-color-secondary);\n\t\t}\n\t\tp {\n\t\t\tcursor: pointer;\n\t\t\ttext-align: left;\n\t\t\tfont-size: 16px;\n\t\t\tfont-family: AppFontBold, sans-serif;\n\n\t\t\tline-height: var(--modal-info-desc-line-height);\n\t\t\tpadding-bottom: 10px;\n\t\t\tcolor: var(--ion-color-primary);\n\t\t\ttext-decoration: underline;\n\t\t\t@include mobile {\n\t\t\t\twidth: 50%;\n\t\t\t\ttext-align: right;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.menge {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\th5 {\n\t\tfont-family: AppFontBold, sans-serif;\n\t\tfont-size: 18px;\n\t\ttext-transform: uppercase;\n\t}\n\tmargin: 0px 20px 20px;\n}\n\nion-button {\n\tposition: relative;\n\n\t.buuton-text {\n\t\tfont-size: var(--modal-info-button-font-size);\n\t\tcolor: var(--color-black);\n\t\tfont-family: AppFont, sans-serif;\n\t\tmargin-right: 0;\n\t}\n\t.button-icon {\n\t\tposition: absolute;\n\t\tright: 5px;\n\t\theight: 34px;\n\t\twidth: 34px;\n\t}\n}\n\nion-toolbar {\n\theight: 60px;\n\tdisplay: flex;\n\talign-items: center;\n\t--background: var(--background-color);\n\tion-title {\n\t\tfont-weight: 100;\n\t\tpadding-inline: unset !important;\n\t\tfont-size: 16px;\n\t\ttext-align: left;\n\t\tmargin-left: 40px;\n\t\tfont-family: AppFontBold, sans-serif;\n\t}\n\tion-button {\n\t\t--background: transparent;\n\t\t--background-activated: transparent;\n\t\t--background-focused: transparent;\n\t\t--background-hover: transparent;\n\t}\n\n\tion-icon {\n\t\tpadding: 8px;\n\t\tfont-size: 15px;\n\t}\n}\nswiper-container {\n\twidth: 100% !important;\n\theight: 100% !important;\n}\n\nswiper-slide {\n\twidth: 100% !important;\n}\nion-page {\n\tbackground: transparent;\n}\n.slider-select-half {\n\theight: 100%;\n\twidth: 100%;\n}\n.separator {\n\theight: 14px;\n\twidth: 100%;\n\t// background: url('../../../assets/icon/separator_doted.svg') no-repeat center center/ 100% 100%;\n\t@include desktop {\n\t\t// background: url('../../../assets/icon/separator_doted.svg') no-repeat center center/ 100% 130%;\n\t\t@media (max-height: 750px) {\n\t\t\theight: 11px;\n\t\t}\n\t}\n}\n.allergens {\n\tmargin: 5px 20px;\n\tapp-accordion-list {\n\t\twidth: 100%;\n\t}\n}\n.padding-block {\n\tpadding: 0px 20px;\n}\n.vertical-line {\n\tcontent: ' ';\n\twidth: 1px;\n\theight: 20px;\n\tcolor: white;\n\tbackground: white;\n\tmargin-inline: 10px;\n}\n.add-background {\n\t// background: black url(../../../assets/background/background.png)  no-repeat center center / 100% 100% !important;\n\tbackground-size: cover;\n}\n.button-footer-block {\n\tmargin: 0px !important;\n\tbackground: #ffffff !important;\n\tpadding: 24px 40px;\n\tposition: relative;\n\twidth: 100%;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-size: 14px;\n\tborder-top: 1px solid #e8ecef;\n\n\t// Mobile: make button sticky at bottom\n\t@include mobile {\n\t\tposition: fixed;\n\t\tbottom: 0;\n\t\tleft: 0;\n\t\tz-index: 999;\n\t\tbox-shadow: 0px -2px 16px rgba(7, 38, 51, 0.08);\n\t\tborder-top: 1px solid #e8ecef;\n\t\tpadding: 20px;\n\t}\n\n\t@include desktop {\n\t\twidth: 100%;\n\t\tpadding: 32px 60px;\n\t}\n\n\t.left-button {\n\t\tbackground: #2d69aa;\n\t\twidth: 100%;\n\t\tmax-width: none;\n\t\theight: 58px;\n\t\tborder-radius: 12px;\n\t\tborder: none;\n\t\tcursor: pointer;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\ttransition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n\t\tbox-shadow: 0px 4px 16px rgba(45, 105, 170, 0.3);\n\n\t\t&:hover {\n\t\t\tbackground: #245489;\n\t\t\ttransform: translateY(-2px);\n\t\t\tbox-shadow: 0px 8px 24px rgba(45, 105, 170, 0.4);\n\t\t}\n\n\t\t&:active {\n\t\t\ttransform: translateY(0);\n\t\t}\n\n\t\t&.disabled {\n\t\t\topacity: 0.5;\n\t\t\tbackground: #b8c9d9;\n\t\t\tborder-color: transparent;\n\t\t\tcursor: not-allowed;\n\t\t\tpointer-events: none;\n\t\t\tbox-shadow: none;\n\t\t}\n\t\t.buuton-text {\n\t\t}\n\n\t\th2,\n\t\tp {\n\t\t\tfont-family: BricolageGrotesque;\n\t\t\tfont-weight: 600;\n\t\t\tfont-size: 16px;\n\t\t\tline-height: 150%;\n\t\t\tletter-spacing: 0.02em;\n\t\t\ttext-align: center;\n\t\t\tvertical-align: middle;\n\t\t\ttext-transform: uppercase;\n\t\t\tcolor: #fff;\n\t\t\tmargin: 0;\n\t\t}\n\t\t@include mobile {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\n\t.button-checkout {\n\t\twidth: fit-content;\n\t\tmax-width: 50%;\n\t\theight: 54px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tbackground: #2d69aa;\n\t\tborder-radius: 26px;\n\t\t.left-price {\n\t\t\tbackground: #fff;\n\t\t\theight: 100%;\n\t\t\tborder-radius: 26px;\n\t\t\tborder: 1px solid #2d69aa;\n\t\t\tpadding: 0px 10px;\n\t\t\tposition: relative;\n\n\t\t\t.option-total-quantity {\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: -10px;\n\t\t\t\tright: 0;\n\t\t\t\theight: 20px;\n\t\t\t\twidth: 20px;\n\t\t\t\tborder: 1px solid #000000;\n\t\t\t\tborder-radius: 50px;\n\t\t\t\tbackground: #fff;\n\t\t\t\tcolor: #072633;\n\t\t\t\tdisplay: flex;\n\t\t\t\tjustify-content: center;\n\t\t\t\talign-items: center;\n\n\t\t\t\tfont-family: BricolageGrotesque;\n\t\t\t\tfont-size: 17px;\n\t\t\t\tletter-spacing: 0.08em;\n\t\t\t\ttext-align: center;\n\t\t\t\tvertical-align: middle;\n\t\t\t\ttext-transform: uppercase;\n\t\t\t}\n\t\t}\n\t\t&:hover {\n\t\t\t// background: var(--ion-color-primary-tint);\n\t\t}\n\t\t&.disabled {\n\t\t\topacity: 0.5;\n\t\t}\n\t\t&.disabled {\n\t\t\topacity: 0.5;\n\t\t}\n\t\tp {\n\t\t\tfont-family: BricolageGrotesque;\n\t\t\tfont-size: 17px;\n\t\t\tline-height: 120%;\n\t\t\tletter-spacing: 2%;\n\t\t\ttext-align: center;\n\t\t\tvertical-align: middle;\n\t\t\ttext-transform: uppercase;\n\t\t}\n\n\t\t.right-checkout {\n\t\t\tcursor: pointer;\n\t\t\tpadding: 0px 15px 0px 10px;\n\n\t\t\tp {\n\t\t\t\tfont-family: BricolageGrotesque;\n\t\t\t\tfont-weight: 700;\n\t\t\t\tfont-size: 17px;\n\t\t\t\tline-height: 120%;\n\t\t\t\tletter-spacing: 2%;\n\t\t\t\ttext-align: center;\n\t\t\t\tvertical-align: middle;\n\t\t\t\ttext-transform: uppercase;\n\t\t\t\tcolor: var(--color-white);\n\t\t\t}\n\t\t\ttext-transform: uppercase;\n\t\t\ttext-align: center;\n\t\t}\n\t}\n}\n.center-element {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n.style-block {\n\theight: 100%;\n\toverflow-y: auto;\n\tpadding-bottom: 80px;\n\t@include mobile {\n\t\theight: auto;\n\t\toverflow-y: unset;\n\t}\n}\n\n@keyframes pulseColor {\n\t0% {\n\t\tcolor: var(--ion-color-primary);\n\t}\n\t30% {\n\t\tcolor: var(--color-black);\n\t}\n\t60% {\n\t\tcolor: var(--ion-color-primary);\n\t}\n\t100% {\n\t\tcolor: var(--color-black);\n\t}\n}\n.show-option-groups {\n\tdisplay: flex;\n\tcursor: pointer;\n\talign-items: center;\n\tjustify-content: space-between;\n\th1 {\n\t\ttext-transform: uppercase;\n\t\tpadding: 10px 20px;\n\t}\n\t&.error-item {\n\t\th1 {\n\t\t\tcolor: var(--color-black);\n\t\t\tanimation: pulseColor 4s infinite alternate;\n\t\t\ttext-transform: uppercase;\n\t\t}\n\t}\n\tion-icon {\n\t\ttransition: rotate 0.3s ease-in-out;\n\t\tmargin-right: 20px;\n\t\twidth: 15px;\n\t\theight: 15px;\n\t\t&.isOpen {\n\t\t\trotate: 180deg;\n\t\t}\n\t}\n}\n.delete-option {\n\tposition: absolute;\n\tbottom: -1px;\n\tright: 0%;\n\tz-index: 99;\n\tcolor: black;\n\tbackground: white;\n\tborder-top-left-radius: 15px;\n\ttext-align: center;\n\tpadding: 7px;\n\tborder-top: 2px dotted black;\n\tborder-left: 2px dotted black;\n\tp {\n\t\tfont-size: 13px;\n\t\tfont-family: 'AppFontBold';\n\t\ttext-transform: uppercase;\n\t\tcolor: var(--ion-color-primary);\n\t}\n}\n.vegan-block {\n\tdisplay: flex;\n\talign-items: center;\n\tion-img {\n\t\twidth: 35px;\n\t\theight: 24px;\n\t}\n\tp {\n\t\ttext-transform: capitalize;\n\t\tmargin-right: 5px;\n\t\tfont-size: 12px;\n\t\tcolor: var(--ion-color-secondary);\n\t}\n}\n.input-notes {\n\tpadding: 20px 10px;\n\tposition: relative;\n\t// border-top: 1px solid var(--color-black);\n\tion-label {\n\t\tposition: absolute;\n\t\ttop: 13px;\n\t\tleft: 4%;\n\t\tbackground: #fff;\n\t\tcolor: #807d7d;\n\t\tfont-size: 11px;\n\t\tz-index: 2;\n\t\tpadding: 0 5px;\n\t}\n\tion-item {\n\t\tborder: 1px solid #e5e5e5;\n\t\t--background: transparent;\n\t\tmargin-bottom: 10px;\n\t\tmargin-top: 0px;\n\t\t--padding-start: 0px;\n\t\tcolor: #072633;\n\t\tfont-size: 14px;\n\t\tpadding: 15px;\n\t\tion-input {\n\t\t\tfont-family: AppFontBold;\n\t\t\tfont-size: 14px;\n\t\t\tline-height: 90%;\n\t\t\tletter-spacing: 0%;\n\t\t\tvertical-align: middle;\n\t\t\ttext-transform: uppercase;\n\t\t}\n\t}\n\t.container {\n\t\tposition: relative;\n\t\tion-label {\n\t\t\tfont-family: AppFont;\n\t\t\tfont-size: 11px;\n\t\t\tline-height: 85%;\n\t\t\tletter-spacing: 0%;\n\t\t\ttext-align: center;\n\t\t\tvertical-align: middle;\n\t\t\ttext-transform: capitalize;\n\n\t\t\tcolor: var(--color-black);\n\t\t}\n\t}\n}\n.filters {\n\twidth: 100%;\n\tapp-menu-list-filters {\n\t\twidth: 100%;\n\t}\n}\n.text-block {\n\t// margin-bottom: auto;\n\t// margin-top: auto;\n}\n.price-row {\n\tdisplay: flex;\n\tjustify-content: flex-start;\n\talign-items: center;\n\tmargin-bottom: 32px;\n\tmargin-top: auto;\n\n\t.price {\n\t\tfont-family: BricolageGrotesque;\n\t\tfont-size: 28px;\n\t\tfont-weight: 700;\n\t\tline-height: 120%;\n\t\tletter-spacing: -0.01em;\n\t\ttext-align: left;\n\t\tvertical-align: middle;\n\t\ttext-transform: none;\n\t\tcolor: #072633;\n\n\t\t@include desktop {\n\t\t\tfont-size: 32px;\n\t\t}\n\t}\n\n\t.kcall {\n\t\tposition: relative;\n\n\t\tfont-size: 14px;\n\t\tline-height: 16.8px;\n\t\tletter-spacing: 0%;\n\t\ttext-align: center;\n\t\ttext-transform: uppercase;\n\t}\n\t.kcall,\n\t.tags {\n\t\tposition: relative;\n\t\theight: 17px;\n\t\tmargin-left: 12px;\n\t}\n\n\t.kcall::before,\n\t.tags::before {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\tleft: -6px;\n\t\twidth: 1.5px;\n\t\theight: 100%;\n\t\tbackground: var(--color-black);\n\t}\n}\n\n.opt-desc-row {\n\tposition: relative;\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\n\t.option-group-limit {\n\t\theight: 100%;\n\t\twidth: fit-content;\n\t\tposition: absolute;\n\t\tleft: 4%;\n\t\ttop: 50%;\n\t\ttransform: translate(0, -50%);\n\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\n\t\tfont-family: BricolageGrotesque;\n\t\tfont-size: 14px;\n\t\tline-height: 120%;\n\t\tletter-spacing: 0%;\n\t\tvertical-align: middle;\n\t\ttext-transform: uppercase;\n\t}\n\n\t.option-group-description {\n\t\tmax-width: 37%;\n\t\tposition: relative;\n\t\tfont-family: Title;\n\t\tfont-size: 24px;\n\t\tline-height: 120%;\n\t\tletter-spacing: 0%;\n\t\ttext-align: center;\n\t\tvertical-align: middle;\n\t\ttext-transform: uppercase;\n\n\t\t&::before,\n\t\t&::after {\n\t\t\tcontent: '';\n\t\t\tposition: absolute;\n\t\t\ttop: 50%;\n\t\t\twidth: 50px;\n\t\t\theight: 2px;\n\t\t\tbackground: var(--color-black);\n\t\t}\n\n\t\t&::before {\n\t\t\ttransform: translate(-100%, 0px);\n\n\t\t\tleft: 0%;\n\t\t}\n\t\t&::after {\n\t\t\ttransform: translate(100%, 0px);\n\t\t\tright: 0%;\n\t\t}\n\t}\n}\nion-textarea.custom {\n\t--border-width: 0;\n}\n.quantity-selector-block {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tpadding-bottom: 25px;\n\tmargin-bottom: 25px;\n\tborder-bottom: 1px solid #dce8f5;\n\n\t.quantity-title {\n\t\tfont-family: BricolageGrotesque;\n\t\tfont-weight: 700;\n\t\tfont-size: 16px;\n\t\ttext-transform: capitalize;\n\t\tcolor: #393939;\n\t}\n}\n.quantity-selector {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tborder: 1px solid #9e5f2c;\n\tborder-radius: 6px;\n\twidth: -moz-fit-content;\n\twidth: fit-content;\n\tbackground: transparent;\n\tz-index: 999;\n\n\t.quantity-btn {\n\t\twidth: 9px;\n\t\theight: 11px;\n\t\tmargin: 0px 10px;\n\t\tcursor: pointer;\n\t}\n\t.quantity {\n\t\twidth: 30px;\n\t\theight: 30px;\n\t\tfont-family: AppFontBold;\n\t\tborder-left: 1px solid #9e5f2c;\n\t\tborder-right: 1px solid #9e5f2c;\n\t\tfont-size: 15px;\n\t\tline-height: 85%;\n\t\tletter-spacing: 0%;\n\t\ttext-align: center;\n\t\tvertical-align: middle;\n\t\ttext-transform: capitalize;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t}\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
